import React, { useState } from "react";
import emailjs from "@emailjs/browser";

import "../styles/waitlist.css";

import logo from "../assets/images/logo.png";
import bgImage from "../assets/images/waitlist-bg.png";

import w1 from "../assets/icons/w-1.svg";
import w2 from "../assets/icons/w-2.svg";
import w3 from "../assets/icons/w-3.svg";
import w4 from "../assets/icons/w-4.svg";
import w5 from "../assets/icons/w-5.svg";

const Waitlist = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) return;

    setLoading(true);
    setMessage("");

    try {
      await emailjs.send(
        "service_sa7sw1o",
        "template_yotdd6c",
        {
          user_email: email,
          submitted_at: new Date().toLocaleString(),
        },
        "NukjTfPyxnkLdsosq"
      );

      setMessage("✅ You're on the waitlist!");
      setEmail("");
    } catch (error) {
      console.error("EmailJS Error:", error);
      setMessage("❌ Failed to join waitlist. Please try again.");
    }

    setLoading(false);
  };

  return (
    <>
      {/* Hero Section */}

      <section
        className="waitlist-hero"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >
        <div className="container">

          <div className="waitlist-content">

            <a href="/">
              <img
                src={logo}
                alt="Sky Terminal"
                className="waitlist-logo"
              />
            </a>

            <h1>
              Join the Future
              <br />
              of <span>TravelFi</span>
            </h1>

            <p>
              Earn rewards from real-world travel with Flight Mining
              and crypto-native travel infrastructure.
            </p>

            <form
              className="waitlist-form"
              onSubmit={handleSubmit}
            >
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <button
                type="submit"
                disabled={loading}
              >
                {loading ? "..." : "→"}
              </button>
            </form>

            {message && (
              <div className="waitlist-message">
                {message}
              </div>
            )}

            <div className="waitlist-note">
              🔒 No spam. Early access only.
            </div>

          </div>

        </div>
      </section>

      {/* Ecosystem Section */}

      <section className="ecosystem-section">

        <div className="container">

          <div className="ecosystem-wrapper">

            <h2 className="ecosystem-title">
              The <span>SkyTerminal</span> Ecosystem
            </h2>

            <div className="row g-4">

              <div className="col-lg col-md-6">
                <div className="eco-card">
                  <img src={w1} alt="" />
                  <h4>Flight Mining</h4>
                  <p>
                    Earn rewards based on
                    real travel distance.
                  </p>
                </div>
              </div>

              <div className="col-lg col-md-6">
                <div className="eco-card">
                  <img src={w2} alt="" />
                  <h4>Delay Insurance</h4>
                  <p>
                    Automatic compensation
                    for delayed flights.
                  </p>
                </div>
              </div>

              <div className="col-lg col-md-6">
                <div className="eco-card">
                  <img src={w3} alt="" />
                  <h4>
                    Flight & Hotel
                    <br />
                    Booking
                  </h4>
                  <p>
                    Crypto-native global
                    travel flights.
                  </p>
                </div>
              </div>

              <div className="col-lg col-md-6">
                <div className="eco-card">
                  <img src={w4} alt="" />
                  <h4>MANGO Rewards</h4>
                  <p>
                    Reusable travel
                    reward economy.
                  </p>
                </div>
              </div>

              <div className="col-lg col-md-6">
                <div className="eco-card">
                  <img src={w5} alt="" />
                  <h4>NFT Passport</h4>
                  <p>
                    Collect airports, countries
                    and travel badges.
                  </p>
                </div>
              </div>

            </div>

          </div>

        </div>

      </section>

      {/* Footer */}

      <section className="waitlist-footer">

        <div className="container">

          <img
            src={logo}
            alt="Sky Terminal"
            className="waitlist-footer-logo"
          />

          <h2 className="footer-heading">
            The next generation of travel rewards is being
            <span> built now.</span>
          </h2>

          <p className="footer-tagline">
            Travel more. Earn more.
            <span> Fly smarter.</span>
          </p>

          <div className="waitlist-footer-social">

            <a
              href="https://t.me/skyterminal_news"
              target="_blank"
              rel="noreferrer"
              className="waitlist-footer-icon"
            >
              <i className="fa-solid fa-paper-plane"></i>
            </a>

            <a
              href="https://x.com/skyterminal_io"
              target="_blank"
              rel="noreferrer"
              className="waitlist-footer-icon"
            >
              <i className="fa-brands fa-x-twitter"></i>
            </a>

            <a
              href="https://medium.com/@skyterminal"
              target="_blank"
              rel="noreferrer"
              className="waitlist-footer-icon"
            >
              <i className="fa-brands fa-medium-m"></i>
            </a>

          </div>

          <div className="footer-copyright">
            © 2026 Sky Terminal. All rights reserved.
          </div>

        </div>

      </section>
    </>
  );
};

export default Waitlist;